import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "./utils";

const badgeVariants = cva(
  "inline-flex h-5 w-fit shrink-0 items-center justify-center gap-1 whitespace-nowrap rounded-full border px-2 py-0 text-2xs font-medium leading-none [&>svg]:size-3 [&>svg]:pointer-events-none outline-none transition-[background-color,color,border-color] duration-[var(--duration-fast)] ease-[var(--ease-default)] overflow-hidden focus-visible:outline-2 focus-visible:outline-[var(--color-brand)] focus-visible:outline-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-[var(--color-bg-sunken)] text-primary",
        secondary:
          "border-transparent bg-[var(--color-bg-surface-hover)] text-[var(--color-text-secondary)]",
destructive:
          "border-transparent bg-[var(--color-danger-soft)] text-[var(--color-danger-strong)]",
        outline:
          "border-transparent bg-background text-[var(--color-text-secondary)]",
        success:
          "border-transparent bg-[var(--color-success-soft)] text-[var(--color-success-strong)]",
        warning:
          "border-transparent bg-[var(--color-warning-soft)] text-[var(--color-warning-strong)]",
        danger:
          "border-transparent bg-[var(--color-danger-soft)] text-[var(--color-danger-strong)]",
        info:
          "border-transparent bg-[var(--color-info-soft)] text-[var(--color-info)]",
        neutral:
          "border-transparent bg-[var(--color-bg-sunken)] text-[var(--color-text-secondary)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<"span"> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : "span";

  return (
    <Comp
      data-slot="badge"
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
